(() => {
  if (window.hexpodHelpReady) return;
  window.hexpodHelpReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-hp-help]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById('hp-help-' + link.dataset.hpHelp);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    if (dialog.open) return;
    const previous = document.querySelector('.hp-help-dialog[open]');
    dialog.hpOpener = previous ? previous.hpOpener : link;
    if (previous) previous.close();
    dialog.showModal();
    document.documentElement.classList.add('hp-help-open');
  });
  document.querySelectorAll('.hp-help-dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-hp-help-close]')) dialog.close();
      else if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      if (document.querySelector('.hp-help-dialog[open]')) return;
      document.documentElement.classList.remove('hp-help-open');
      if (dialog.hpOpener?.isConnected) dialog.hpOpener.focus({preventScroll: true});
    });
  });
})();
